import App from './app.class.js'
import Partial from './partial.class.js'

export { App, Partial }



// WEBPACK FOOTER //
// ./src/index.js